import { User, Users } from "lucide-react";
import { useParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { API, authGet } from "@/lib/api";

export default function GuestViewFloatingButton() {
  const { eventId, shareCode: urlShareCode } = useParams();
  const location = useLocation();
  const [shareCode, setShareCode] = useState(urlShareCode || null);
  const [realEventId, setRealEventId] = useState(eventId || null);

  const isGuestView = location.pathname.startsWith('/e/');

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        if (isGuestView && urlShareCode) {
          // In guest view, we need the real ID to jump back to creator
          const response = await axios.get(`${API}/public/event/${urlShareCode}`);
          const id = response.data.id || (response.data.event && response.data.event.id);
          if (id) setRealEventId(id);
          setShareCode(urlShareCode);
        } else if (eventId) {
          // In creator view, we need the share code to jump to guest view
          const response = await authGet(`/events/${eventId}`);
          setShareCode(response.data.share_code);
          setRealEventId(eventId);
        }
      } catch (err) {
        console.error("Toggle error:", err);
      }
    };
    fetchEvent();
  }, [eventId, urlShareCode, isGuestView]);

  const handleToggle = (targetView) => {
    if (targetView === 'creator' && realEventId) {
      window.location.href = `/event/${realEventId}`;
    } else if (targetView === 'guest' && shareCode) {
      window.location.href = `/e/${shareCode}`;
    }
  };

  // If we are in guest view, we at least have the share code from URL
  // If we are in creator view, we at least have the eventId from URL
  const canShow = isGuestView ? !!urlShareCode : !!eventId;
  if (!canShow) return null;

  return (
    <div className="fixed bottom-[140px] md:bottom-[115px] left-1/2 -translate-x-1/2 z-[99999] animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="bg-white/95 backdrop-blur-2xl rounded-full shadow-[0_10px_30px_rgba(0,0,0,0.15)] p-1 border border-gray-200/60 flex items-center gap-0.5 scale-90 origin-bottom">
        {/* Creator Button */}
        <button
          onClick={() => handleToggle('creator')}
          className={`relative px-4 py-1.5 rounded-full font-black text-[9px] uppercase tracking-[0.15em] transition-all duration-300 flex items-center gap-1.5 ${!isGuestView
            ? 'bg-gradient-to-br from-yellow-400 to-yellow-600 text-white shadow-md'
            : 'bg-transparent text-gray-400 hover:text-gray-900'
            }`}
        >
          <User className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Creator</span>
        </button>

        {/* Trenner */}
        <div className="w-[1px] h-3 bg-gray-200 mx-1" />

        {/* Besucher Button */}
        <button
          onClick={() => handleToggle('guest')}
          className={`relative px-4 py-1.5 rounded-full font-black text-[9px] uppercase tracking-[0.15em] transition-all duration-300 flex items-center gap-1.5 ${isGuestView
            ? 'bg-gradient-to-br from-blue-500 to-blue-700 text-white shadow-md'
            : 'bg-transparent text-gray-400 hover:text-gray-900'
            }`}
        >
          <Users className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Besucher</span>
        </button>
      </div>
    </div>
  );
}
